import PageLayoutContent from './content';
import PageLayoutFooter from './footer';
import PageLayoutHeader from './header';
import PageLayoutWrapper from './wrapper';

const PageLayout = {
  Wrapper: PageLayoutWrapper,
  Header: PageLayoutHeader,
  Content: PageLayoutContent,
  Footer: PageLayoutFooter,
};

export default PageLayout;
